import React from 'react';
import ActionButton from 'components/buttons/action';
import { LiaExternalLinkAltSolid } from 'react-icons/lia';
import { Tooltip } from 'antd';
type ColumnRenderProps = {
    value: string;
    column: string;
    index: number;
    widths: any;
    row: any;
};

const ColumnRender = ({ value, column, index, widths, row }: ColumnRenderProps) => {
    const content = value ? (
        <div className="VZ__table__action__button">
            <span
                className="table__item__select transition"
                key={column}
                onClick={() => {
                    const sitePath = window.location;
                    const siteURL = sitePath.origin;
                    window.open(`${siteURL}/${row.LINK}`, '_blank');
                }}
            >
                {value}
            </span>
            <ActionButton
                title=""
                icon={
                    <>
                        <Tooltip title="Click for more details">
                            <LiaExternalLinkAltSolid />
                        </Tooltip>
                    </>
                }
                type="link-table"
                onClick={() => {
                    const sitePath = window.location;
                    const siteURL = sitePath.origin;
                    window.open(`${siteURL}/${row.LINK}`, '_blank');
                }}
            />
        </div>
    ) : (
        <span key={column}>{'--'}</span>
    );

    // if (index === 1) {
    //     return <div className="VZ__table__action__button">{content}</div>;
    // }

    if (widths[index] !== '0') {
        return <>{content} </>;
    }
};

export default ColumnRender;
